import { FC, useMemo } from 'react';

import type { ElementAnimationStyle } from '@adflow/utils';

import { AdElementRenderProps } from '../types';
import { AdArtwork, AdFrame, findRootSvgElement } from './Ad/AdArtwork';

import '../css-reset.css';

type Props = {
  adElements: Array<AdElementRenderProps>;
  isPreview?: boolean;
  svgIdPrefix?: string | null;
  animationOverrides?: ReadonlyMap<string, ElementAnimationStyle> | null;
  animationTargetIds?: ReadonlySet<string> | null;
  /** When false, off-frame elements remain visible (editor stage). Default true for delivery/capture. */
  clipToFrame?: boolean;
};

const Ad: FC<Props> = ({
  adElements,
  isPreview,
  svgIdPrefix,
  animationOverrides,
  animationTargetIds,
  clipToFrame = true,
}) => {
  const rootElement = useMemo(() => findRootSvgElement(adElements), [adElements]);

  return (
    <AdFrame rootElement={rootElement} clipToFrame={clipToFrame}>
      <AdArtwork
        adElements={adElements}
        isPreview={isPreview}
        svgIdPrefix={svgIdPrefix}
        animationOverrides={animationOverrides}
        animationTargetIds={animationTargetIds}
      />
    </AdFrame>
  );
};

Ad.displayName = 'AdflowAd';

export default Ad;
